export const DEFAULT_MIN_WIDTH = "250px";
export const GRID_ITEM_TYPES = {
    ASSET_CONTENT_CARD: "Asset Content Card"
};
Object.freeze(GRID_ITEM_TYPES);
export default GRID_ITEM_TYPES;
